import { render, staticRenderFns } from "./BaseStoreLocator.vue?vue&type=template&id=8f63ca7a&"
import script from "./BaseStoreLocator.vue?vue&type=script&lang=js&"
export * from "./BaseStoreLocator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f63ca7a')) {
      api.createRecord('8f63ca7a', component.options)
    } else {
      api.reload('8f63ca7a', component.options)
    }
    module.hot.accept("./BaseStoreLocator.vue?vue&type=template&id=8f63ca7a&", function () {
      api.rerender('8f63ca7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseStoreLocator.vue"
export default component.exports